import { DROPDOWN_COUNTRIES } from 'sharedKernel/constants'

export const normalizeCountryCode = (country?: string | null): string => {
  if (country == null || String(country).trim() === '') return 'BR'
  const trimmed = String(country).trim()
  if (trimmed === 'Brasil' || trimmed === 'Brazil') return 'BR'
  const byValue = DROPDOWN_COUNTRIES.find(o => o.value === trimmed)
  if (byValue) return byValue.value
  const byLabel = DROPDOWN_COUNTRIES.find(
    o => o.label.toLowerCase() === trimmed.toLowerCase()
  )
  return byLabel?.value ?? trimmed
}
